/**
 * USDT提款
 * moss
 */
import { connect } from "react-redux";
import { Fragment } from 'react'
import "./usdt-withdrawal.scss";


class UsdtWithdrawal extends React.Component {
    constructor() {
        super();
        this.state = {
            stepIndex:1,
            showWithdrawal:false,
            showCheckSecPwd:true,
            usdtData:{
                wraptime:{starttime:'',endtime:''},
                user:{username:''},
                addresses:[]
            },
            verifyUsdtData:{
                addresses:{address:''},
                user:{username:''},
                },
            checkcode:'',
            coinTypeList:[],
            addressList:[],
        };
    }
    componentWillUnmount() {
        this.clearTimeOutTimer()
    }
    componentDidMount() {
    }
    reset= () =>{
        // ReactDOM.findDOMNode(this.refs.secPwd).value;
        this.refs.secPwd.value = '';
    }
    submit= () =>{
        const {hasGooglePwd} = this.props
        const password = this.refs.secPwd.value
        const code = hasGooglePwd ? this.refs.GooglePwd.value : null
        let nextcon = "user", nextact = "bindsequestion";
        if(password == ''){
            return this.props.$$BASE.openAlert('请enter the withdrawal password!')
        }
        if (hasGooglePwd && code == null) {
            return this.props.$$BASE.openAlert('请输入谷歌验证码!')
        }
        this.props.$$USER.checkSecurityPass(nextcon, nextact, password, (e) => {
            this.setState({
                checkcode:e.msg.checkcode
            })
            if(e.status == 1){
                this.props.$$USER.getWithdrawalListForUsdt(e.msg.checkcode,(res)=>{
                    if (res.status == 10000) {
                        let addressList = res.data.addresses.filter(obj=>obj.bank_name == res.data.available_cointype[0].currency_code)
                        this.setState({
                            usdtData:res.data,
                            coinTypeList:res.data.available_cointype,
                            showWithdrawal:true,
                            showCheckSecPwd:false,
                            addressList:addressList
                        })
                    }else {
                        return this.props.$$BASE.openAlert(res.message)
                    }
                })
                this.refs.secPwd.value = '';
            }
        },code);

    }
    goCheckPwd=()=>{
        this.setState({
            stepIndex:1,
            showWithdrawal:false,
            showCheckSecPwd:true,
        })
        if(this.state.stepIndex == 3){
            this.clearTimeOutTimer()
        }
    }
    handleStepIndex = (index)=>{
        const money = this.refs.withdrawalValue.value
        const address = this.refs.address.value
        let stepIndex = this.state.stepIndex

        if (index == -1 && this.state.stepIndex == 1) {
            return
        }
        if (index == 1&& this.state.stepIndex == 3) {
            return
        }
        if (index==-1){
            this.setState({
                stepIndex: stepIndex+index
            })
        }
        if (stepIndex == 1 && index == 1) {
            if (money > this.state.usdtData.max_money || money < this.state.usdtData.min_money) {
                return this.props.$$BASE.openAlert('请输入正确的提币数量')
            }
            this.props.$$USER.checkWithdrawalDataForUsdt([this.state.checkcode,address,money],(res)=>{
                if (res.status == 10000) {
                    this.setState({
                        verifyUsdtData:res.data,
                        stepIndex: stepIndex+index
                    })
                }else {
                    if(res.status == 30713){
                        this.goCheckPwd()
                    }
                    return this.props.$$BASE.openAlert(res.message)
                }
            })
        }
        if (stepIndex == 2 && index == 1) {
            this.props.$$USER.withdrawalForUsdt([this.state.checkcode,address,money,this.state.verifyUsdtData.withdraw_token],(res)=>{
                if (res.status == 10000) {
                    this.setState({
                        stepIndex: stepIndex+index
                    })
                    this.setTimeOutTimer()
                }else {
                    if (res.status == 30519) {
                        let query = '&money='+res.data.money+'&check='+res.data.check+'&cardid='+res.data.cardid
                        this.props.$$BASE.openIframeModal('emaildeposit/main?controller=security&action=withdrawdisplay'+query, '姓名验证', 820, 500);
                        this.props.onclose()
                    }else {
                        if(res.status == 30713){
                            this.goCheckPwd()
                        }
                        return this.props.$$BASE.openAlert(res.message)
                    }
                }
            })
        }
    }
    setTimeOutTimer=()=>{
        this.setTimeOutTimer = setTimeout(()=>{
            this.setState({
                stepIndex:1,
                showWithdrawal:false,
                showCheckSecPwd:true,
            })
        },8000)
    }
    clearTimeOutTimer=()=>{
        clearTimeout(this.setTimeOutTimer)
    }
    handleCoinType=()=>{
        let coinTypeId = this.refs.coinType.value
        let coinTypeText = this.state.coinTypeList.filter(obj=> obj.id == coinTypeId)[0].currency_code
        let address = this.state.usdtData.addresses.filter(obj=>obj.bank_name == coinTypeText)
        this.setState({
            addressList:address
        })
    }
    handleMoney=()=>{
        let money = this.refs.withdrawalValue.value
        money = money.replace(/^(0+)|[^\d]+/g,'')
        this.refs.withdrawalValue.value = money
        this.setState({
            coinAmount:money
        })
    }
    render() {
        const __user = this.props.__USER;
        const info = __user.info;
        const {hasGooglePwd} = this.props
        return (
          <Fragment>
            <div className="report-modal-header modal-title">提款</div>
            <div className="check-sec-pwd" style={{ display: this.state.showCheckSecPwd ? "block" : "none" }}>
              <div className="value-box">
                <span className="input-label">enter the withdrawal password：</span>
                <span className="value">
                  <input type="password" ref="secPwd" minLength="6" maxLength="16" /> <br />
                </span>
              </div>
              {hasGooglePwd && (
                <div className="value-box">
                  <span className="input-label">输入谷歌验证码：</span>
                  <span className="value">
                    <input type="password" ref="GooglePwd" minLength="6" maxLength="16" /> <br />
                  </span>
                </div>
              )}
              <div className="actions">
                <button onClick={this.reset} className="big">
                  reset
                </button>
                <button onClick={this.submit} className="big submit">
                  确认
                </button>
              </div>
            </div>
            <div className="withdrawal-content" style={{ display: this.state.showWithdrawal ? "block" : "none" }}>
              <ul className="step clerafix">
                <li className="step-1 fl">
                  <span className={this.state.stepIndex > 0 ? "active" : ""}>
                    <span className="step-num">1</span>
                    <span className="step-text">设置提款请求</span>
                  </span>
                  <span className="arrow-right"></span>
                </li>
                <li className="step-2 fl">
                  <span className={this.state.stepIndex > 1 ? "active" : ""}>
                    <span className="step-num">2</span>
                    <span className="step-text">确认提款信息</span>
                  </span>
                  <span className="arrow-right"></span>
                </li>
                <li className="step-3 fl">
                  <span className={this.state.stepIndex > 2 ? "active" : ""}>
                    <span className="step-num">3</span>
                    <span className="step-text">完成申请</span>
                  </span>
                </li>
              </ul>
              <p className="agawin-text" style={{ display: this.state.stepIndex == 1 ? "block" : "none" }}>
                <span className="alert-icon" />
                <span>注意:</span>
                <span>每天提款限制</span>
                <span className="color-font"> {this.state.usdtData.times} </span>
                <span>次，</span>
                <span>您已提款</span>
                <span className="color-font"> {this.state.usdtData.count} </span>
                <span>次，</span>
                <span>
                  提款时间为 {this.state.usdtData.wraptime.starttime} 至 {this.state.usdtData.wraptime.endtime}{" "}
                  您今日提款剩余额度为
                </span>
                <span className="color-font"> {this.state.usdtData.rest} </span>
                <span>元</span>
              </p>
              <ul className="form-value-list" style={{ display: this.state.stepIndex == 1 ? "block" : "none" }}>
                <li>
                  <span className="lable-box">用户名：</span>
                  <span className="usdt-detail">{this.state.usdtData.user.username}</span>
                </li>
                <li>
                  <span className="lable-box">可提款金额：</span>
                  <span className="usdt-detail pink">{this.state.usdtData.availablebalance}</span>
                </li>
                <li>
                  <span className="lable-box">提款方式：</span>
                  <span className="usdt-detail">
                    <select ref={"coinType"} onChange={this.handleCoinType}>
                      {this.state.coinTypeList.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.currency_code}
                        </option>
                      ))}
                    </select>
                  </span>
                </li>
                <li>
                  <span className="lable-box">当前汇率：</span>
                  <span className="usdt-detail pink">
                    {this.state.usdtData.current_rate} （可提币数量≈{this.state.usdtData.available_usdt}）
                  </span>
                </li>
                <li className="withdrawal-item">
                  <span className="lable-box">提币数量：</span>
                  <span className="usdt-detail">
                    <input type="number" onKeyUp={this.handleMoney} ref="withdrawalValue" />
                    <span>
                      单笔最低提币数量{this.state.usdtData.min_money}个，最高{this.state.usdtData.max_money}个
                    </span>
                  </span>
                </li>
                <li>
                  <span className="lable-box">提币地址：</span>
                  <span className="usdt-detail">
                    <select ref={"address"}>
                      {this.state.addressList.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.account}
                        </option>
                      ))}
                    </select>
                  </span>
                </li>
              </ul>
              <ul
                className="form-value-list form-value-list-step2"
                style={{ display: this.state.stepIndex == 2 ? "block" : "none" }}>
                <li>
                  <span className="lable-box">用户名：</span>
                  <span className="usdt-detail username">{this.state.verifyUsdtData.user.username}</span>
                </li>
                <li>
                  <span className="lable-box">可提款金额：</span>
                  <span className="usdt-detail pink">{this.state.verifyUsdtData.availablebalance}</span>
                </li>
                <li>
                  <span className="lable-box">提币数量：</span>
                  <span className="usdt-detail pink">
                    {this.state.coinAmount}({this.state.verifyUsdtData.money}元)
                  </span>
                </li>
                <li>
                  <span className="lable-box">当前汇率：</span>
                  <span className="usdt-detail">{this.state.verifyUsdtData.rate}</span>
                </li>
                <li>
                  <span className="lable-box">提款手续费：</span>
                  <span className="usdt-detail">{this.state.verifyUsdtData.fee}</span>
                </li>
                <li>
                  <span className="lable-box">实际到账数量：</span>
                  <span className="usdt-detail">{this.state.verifyUsdtData.quantity}</span>
                </li>
                <li>
                  <span className="lable-box">提币地址：</span>
                  <span className="usdt-detail">{this.state.verifyUsdtData.addresses.address}</span>
                </li>
              </ul>
              <div className="withdrawal-success" style={{ display: this.state.stepIndex == 3 ? "block" : "none" }}>
                <div className="withdrawal-success-content">
                  <div className="wsc-1">
                    <span>
                      <span className={"icon-success"} />
                    </span>
                    <span>
                      <p>账户提款申请成功</p>
                      <p>(提款进度请关注站内信通知)</p>
                      <p onClick={this.goCheckPwd}>还要提现</p>
                    </span>
                  </div>
                  <div className="wsc-2">8秒后系统将自动跳转到提现页</div>
                </div>
              </div>
              <div className="line usdt" style={{ display: this.state.stepIndex == 3 ? "none" : "block" }} />
              <div className="step-btn-box" style={{ display: this.state.stepIndex == 3 ? "none" : "flex" }}>
                <p style={{ display: this.state.stepIndex > 1 ? "block" : "none" }} onClick={(e) => this.handleStepIndex(-1)}>
                  上一步
                </p>
                <p onClick={(e) => this.handleStepIndex(1)}>下一步</p>
              </div>
            </div>
          </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        __USER: state.user
    };
}

function mapDispatchToProps(dispatch) {
    return {
        $$BASE: bindActionCreators(baseAction, dispatch),
        $$USER: bindActionCreators(userAction, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UsdtWithdrawal);
